import { render, staticRenderFns } from "./ReportesTable.vue?vue&type=template&id=ed22f060&scoped=true"
import script from "./ReportesTable.vue?vue&type=script&lang=ts"
export * from "./ReportesTable.vue?vue&type=script&lang=ts"
import style0 from "./ReportesTable.vue?vue&type=style&index=0&id=ed22f060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed22f060",
  null
  
)

export default component.exports